import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";






import ToolTip from "../common/ToolTip";
import usePermission from "../../usePermission";




import { InlineDownloadProgress } from "../common/InlineDownloadProgress";
import CustomerContext from "../../context/customer/CustomerContext";
import { useContext } from "react";
import { TrackNowButton } from "../ui/TrackNowButton";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

export default function Toolbox(props: {
  displayComments: () => void;
  displayClientFiling: () => void;
  displayAddClientFiling: () => void;
  displayAttachments: () => void;
  displayHistory: () => void;
  updateBulkStatus: () => void;
  displayDocuments: () => void;
  displayConsolidatedView: () => void;
  // displayClientSpecificConsolidatedView: () => void;
  downloadData: () => void;
  downloadDataHistory: () => void;
  editMasterFilling: () => void;
  addMasterFilling: () => void;
  // deleteMasterRecord: () => void;
  displayCalendarView: () => void;
  deleteRecord: () => void;
  deleteClientFiling: () => void;
  isMasterFiling: boolean;
  isTabValue: boolean;
  selectedClientId: any;
  isDisabled: boolean;
  hasTrackNowAccess: boolean;
  hasPostAwaradAccess: boolean;
  downloadProgress?: number;
  downloadStatusMsg?: string;
  isDownloading?: boolean;
}) {
  const navigate = useNavigate();
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor =
    activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const customerContext = useContext(CustomerContext);
  const { selectedCustomer } = customerContext;
  const showCusotmerForm = () => {
    navigate("/customer");
  };

  const displayClientFiling = () => {
    props.displayClientFiling();
  };

  const displayAddClientFiling = () => {
    props.displayAddClientFiling();
  };

  const displayComments = () => {
    props.displayComments();
  };

  const displayAttachments = () => {
    props.displayAttachments();
  };

  const displayHistory = () => {
    props.displayHistory();
  };
  const updateBulkStatus = () => {
    props.updateBulkStatus();
  };

  const displayDocuments = () => {
    props.displayDocuments();
  };

  const displayConsolidatedView = () => {
    props.displayConsolidatedView();
  };
  // const displayClientSpecificConsolidatedView = () => {
  //   props.displayClientSpecificConsolidatedView();
  // };

  const downloadData = () => {
    props.downloadData();
  };
  const downloadDataHistory = () => {
    props.downloadDataHistory();
  };

  const editFilingMaster = () => {
    props.editMasterFilling();
  };

  const showFilingMasterForm = () => {
    props.addMasterFilling();
  };

  const deleteClientAddedFiling = () => {
    props.deleteClientFiling();
  };

  const displayCalendarView = () => {
    props.displayCalendarView();
  };

  const deleteFiling = () => {
    props.deleteRecord();
  };

  const closeAlert = () => {
    setShowAlert(() => false);
  };
  const hasChangeStatusPermission = usePermission(
    "ClientFilingList",
    "changeStatus",
  );
  const hasStaffAssignedPermission = usePermission(
    "ClientFilingList",
    "changeStaff",

  );
  const hasAddClientFilingPermission = usePermission(
    "ClientFilingList",
    "addFiling",
    props.selectedClientId
  );
  console.log("hasAddClientFilingPermission", "hasTrackNowAccess", props.hasTrackNowAccess, props.hasPostAwaradAccess, hasAddClientFilingPermission);


  return (
    <React.Fragment>
      <Box sx={{
        width: "100%",
        bgcolor: "white",
        borderRadius: "50px !important",
        padding: "16px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}>
        <nav aria-label="main mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton sx={{ justifyContent: "center", padding: "8px" }}>
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <GoogleMaterialIcon name="filter_list" color={primaryColor} />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayAddClientFiling}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "addFiling",
                    props.selectedClientId
                  )
                }

                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ListItemIcon sx={{ minWidth: "auto", color: primaryColor }}>
                  <ToolTip title="Deferred Filing">
                    <GoogleMaterialIcon name="person_add" color={primaryColor} />
                  </ToolTip>
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
        <Divider sx={{ width: "80%", bgcolor: primaryColor }} />
        <nav aria-label="secondary mailbox folders" style={{ width: "100%" }}>
          <List sx={{ padding: 0 }}>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton disabled={props.isDisabled} onClick={displayClientFiling} sx={{ justifyContent: "center", padding: "8px" }}>
                <ToolTip title="Home">
                  <GoogleMaterialIcon name="home" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayCalendarView}
                disabled={!props.selectedClientId || !selectedCustomer}
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Tracker Calendar View">
                  <GoogleMaterialIcon name="calendar_month" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={showFilingMasterForm}
                // disabled={
                //   (!props.hasTrackNowAccess && !props.hasPostAwaradAccess) || !props.selectedClientId
                // }
                disabled={
                  (!hasAddClientFilingPermission || (!props.hasTrackNowAccess && !props.hasPostAwaradAccess))
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Add Client Filing Master">
                  <GoogleMaterialIcon name="post_add" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={editFilingMaster}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "clientSpecificFiling",
                    props.selectedClientId
                  ) || props.isTabValue
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Edit Client Filing Master">
                  <GoogleMaterialIcon name="edit" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={deleteClientAddedFiling}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "deleteClientSpecificFiling",
                    props.selectedClientId
                  ) || props.isTabValue
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Delete Client Filing">
                  <GoogleMaterialIcon name="delete" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayComments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "comments",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Comments">
                  <GoogleMaterialIcon name="comment" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayAttachments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "viewFinalAttachment",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Final Attachment">
                  <GoogleMaterialIcon name="attach_file" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayHistory}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "activityHistory",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Activity History">
                  <GoogleMaterialIcon name="history" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayDocuments}
                disabled={
                  !usePermission(
                    "ClientFilingList",
                    "masterFilingRefDoc",
                    props.selectedClientId
                  )
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Reference Documents">
                  <GoogleMaterialIcon name="snippet_folder" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={updateBulkStatus}
                disabled={
                  !hasChangeStatusPermission && !hasStaffAssignedPermission && !props.selectedClientId
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Bulk Update">
                  <GoogleMaterialIcon name="edit_note" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={displayConsolidatedView}
                disabled={
                  !hasChangeStatusPermission && !hasStaffAssignedPermission && !props.selectedClientId
                }
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Consolidated update">
                  <GoogleMaterialIcon name="groups" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
            {props.isTabValue ? (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadDataHistory}
                  disabled={!selectedCustomer}
                  iconColor={primaryColor}
                />
              </ListItem>
            ) : (
              <ListItem disablePadding sx={{ justifyContent: "center" }}>
                <InlineDownloadProgress
                  isDownloading={!!props.isDownloading}
                  progress={props.downloadProgress || 0}
                  statusMsg={props.downloadStatusMsg || ""}
                  onClick={downloadData}
                  disabled={!props.selectedClientId || !selectedCustomer}
                  iconColor={primaryColor}
                />
              </ListItem>
            )}
            <ListItem disablePadding sx={{ justifyContent: "center" }}>
              <ListItemButton
                onClick={deleteFiling}
                disabled={props.isTabValue}
                sx={{ justifyContent: "center", padding: "8px" }}
              >
                <ToolTip title="Defer Filing">
                  <GoogleMaterialIcon name="delete_forever" color={primaryColor} />
                </ToolTip>
              </ListItemButton>
            </ListItem>
          </List>
        </nav>
      </Box>
    </React.Fragment >
  );
}
